import React, { useEffect } from "react";
import Loginbg from "../../assets/login_bg.svg";
import "./login.css";
import SimuleIcon from "../../assets/Simule_icon.svg";
import home from "../../assets/home.svg";
import MetaMaskFox from "../../assets/MetaMask_Fox.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";

function Login() {
  const navigate = useNavigate();
  const { open } = useAppKit();
  const { address, isConnected } = useAppKitAccount();

  // Check if user is already authenticated with valid signature
  useEffect(() => {
    const checkExistingAuth = () => {
      if (isConnected && address) {
        try {
          const storedSignature = localStorage.getItem(address);
          if (storedSignature) {
            const { timestamp } = JSON.parse(storedSignature);
            const twoHoursInMs = 2 * 60 * 60 * 1000;
            const isExpired = !Number.isFinite(Number(timestamp)) || Date.now() - Number(timestamp) > twoHoursInMs;
            
            if (!isExpired) {
              console.log("EXISTING AUTH: Valid signature found, redirecting to map", { address });
              navigate("/map");
              return;
            }
          }
        } catch (error) {
          console.log("EXISTING AUTH: Invalid stored signature, will request new one");
        }
        
        // If no valid signature, let WalletInfo handle the authentication flow
        console.log("NO VALID AUTH: Wallet connected but no valid signature, staying on login for WalletInfo to handle");
      }
    };

    checkExistingAuth();
  }, [isConnected, address, navigate]);

  const handleMetaMaskLogin = async () => {
    try {
      await open();
    } catch (error) {
      console.error("MetaMask connection error:", error);
      toast.error("Failed to connect to MetaMask. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <img src={Loginbg} alt="" aria-hidden="true" className="login-bg-image" />

      <header className="login-header">
        <button className="login-brand" type="button" onClick={() => navigate("/")}>
          <img src={SimuleIcon} alt="" width={40} height={40} />
          <span>Simule</span>
        </button>

        <button className="login-home-link" type="button" onClick={() => navigate("/")}>
          <img src={home} alt="" width={18} height={18} />
          <span>Back to Home</span>
        </button>
      </header>

      <main className="login-main">
        <section className="login-card" aria-labelledby="wallet-access-title">
          <div className="login-card-icon" aria-hidden="true">
            <img src={SimuleIcon} alt="" width={38} height={38} />
          </div>
          <p className="login-eyebrow">YOUR DIGITAL LAND PORTFOLIO</p>
          <h1 id="wallet-access-title">Explore and own digital land</h1>
          <p className="login-description">
            Connect your wallet to mint locations, manage collectibles, and explore the Simule map.
          </p>

          <button className="metamask-btn" type="button" onClick={handleMetaMaskLogin}>
            <img src={MetaMaskFox} alt="" width={22} height={22} />
            <span>Connect wallet</span>
          </button>

          <div className="login-security-note">
            <span className="login-security-dot" aria-hidden="true" />
            Secure connection through your wallet provider
          </div>

          <p className="footer-text">
            By continuing, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>.
          </p>
        </section>
      </main>
    </div>
  );
}

export default Login;
